var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGardifyLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 210.07 59.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-381.75 217.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 381.75,
    y: -217.1,
    width: 210.07,
    height: 59.88
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.86-184.65c-.57-2.2-1.94-6.12-4.45-8.72-1.36-1.41-4.23-5-6.25-11.78a37.39,37.39,0,0,0-5.09-10.21.12.12,0,0,1,.13-.18c4.27,1.1,8,3.94,11,6.62a25.27,25.27,0,0,1,5.23,6.42,35.57,35.57,0,0,1,2.77,6.73c1.62,5.31,1.17,10.1,0,15.46a35,35,0,0,1-1.92,5.58.12.12,0,0,1-.22-.05,46.26,46.26,0,0,0-1.15-9.87",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M418.53-200.76a.11.11,0,0,1,.08-.21c1.14.29,3,.79,4.27,1.21a19.45,19.45,0,0,1,11.66,12.88.12.12,0,0,1-.2.12,13.6,13.6,0,0,0-4.42-3.28c-7.64-3.53-6.51-8-11.39-10.72",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M419.35-188.38a7.62,7.62,0,0,1-4.65,9.72,7.63,7.63,0,0,1-9.71-4.65,7.61,7.61,0,0,1,4.65-9.71,7.61,7.61,0,0,1,9.71,4.64",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.41-157.47c-.11.05-.09.22,0,.22a19.19,19.19,0,0,0,10-2.32c6.08-3.31,7-7.67,6.54-11a83.59,83.59,0,0,0-2.53-9.72.11.11,0,0,0-.19,0c-.85.86-5.45,5.81-5.91,11.2-.33,3.91-2.92,9.77-7.94,11.69",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M418.35-166.07a.11.11,0,0,1,.18.13,18.59,18.59,0,0,1-5.77,6.63c-5.15,3.22-12,.11-13.87-.87a.12.12,0,0,1,.07-.22,36.89,36.89,0,0,0,8.22.06c2.79-.49,5.22-.65,11.17-5.73",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M418.7-170a.12.12,0,0,1,.07.19,20,20,0,0,1-9.11,6.54c-7.84,2.77-14.49,1.48-21.48-5.66a.11.11,0,0,1,.13-.18,13.63,13.63,0,0,0,5.4,1.71,14.09,14.09,0,0,0,3.93-.19c2.33-.42,8.73-2.43,13.14-2.7a35.19,35.19,0,0,1,7.92.29",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.25-193.53s-1.5,8.7.68,14.56c1.61,4.36,5.8,12.09,23.67,7.58a.12.12,0,0,0,0-.23A11.37,11.37,0,0,1,398-177.1c-3.43-5.49-7.45-3.83-10.83-7.59a22.67,22.67,0,0,1-5-8.84",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M391.56-183.78a6,6,0,0,0,5.5-4.83c1.75-8,7-11,10.76-12.84a.11.11,0,0,0-.06-.21c-2.29.19-10.86,1.27-14.85,7A10.77,10.77,0,0,0,391-188c.07,3.09.23,4.05.58,4.18",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M401.2-214c-.08-.06-.1-.17,0-.21,1.7-.73,11.13-4.55,15.8-2,4.9,2.73,6.57,7.15,7.93,12a.11.11,0,0,1-.2.1c-.26-.34-2.8-4-6.41-5.6-4.57-2-6.89-1.34-9.27-1.66A15.85,15.85,0,0,1,401.2-214",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389-185.7a.11.11,0,0,1-.19.1,14.24,14.24,0,0,1-1.74-19.08,16.57,16.57,0,0,1,8-6.41c4.36-1.54,7.81.09,11.14,1.54a.12.12,0,0,1,0,.21c-5.07,2.5-4.51,5.14-8.85,8-5.31,3.51-9.78,7.49-8.35,15.63",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M409-204.27a9,9,0,0,0-6.73.74c-.28.16-.41.23-.46.17s0-.2.43-.59a15.29,15.29,0,0,1,4.74-3.69,13.68,13.68,0,0,1,8.16-.61c5.48,1.13,9.11,6.09,9.89,6.77.14.12.19.28.15.34s-.17,0-.27,0a15.45,15.45,0,0,0-9.83-2.19,21.22,21.22,0,0,1-6.08-.9",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M436.13-175.67c.21,5-3.21,9.5-4.52,11a.12.12,0,0,1-.2-.12,14.45,14.45,0,0,0,.08-10c-1.86-5.79-2.87-8.07-3-13.6a.12.12,0,0,1,.15-.12,9.43,9.43,0,0,1,4,2.79,16.66,16.66,0,0,1,3.53,10",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M472.93-181.09h-.06a7.18,7.18,0,0,1-6.67,3.75,8,8,0,0,1-8.29-8.32,8.21,8.21,0,0,1,8.61-8.42c5.05,0,8.58,3.43,8.58,8.52V-179c0,6.18-3.72,8.58-8.48,8.58-3.86,0-6.93-1.59-8-5.15h2.2c.87,2.27,3.11,3.24,5.83,3.24,3.69,0,6.31-1.84,6.31-6.57Zm-6.41-11a6.15,6.15,0,0,0-6.41,6.41,6.07,6.07,0,0,0,6.41,6.31,6.07,6.07,0,0,0,6.41-6.31,6.15,6.15,0,0,0-6.41-6.41",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M496.19-177.66h-2v-3.79h-.07a7.08,7.08,0,0,1-6.83,4.21,8.06,8.06,0,0,1-8.29-8.42,8.22,8.22,0,0,1,8.62-8.42,8.16,8.16,0,0,1,8.58,8.52Zm-2.17-8a6.16,6.16,0,0,0-6.41-6.41,6.16,6.16,0,0,0-6.42,6.41,6.16,6.16,0,0,0,6.42,6.41,6.16,6.16,0,0,0,6.41-6.41",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M512.19-187v-.23c0-3.33-1.85-4.82-4.57-4.82s-4.57,1.49-4.57,4.82v9.59h-2.17v-9.59c0-4.59,2.76-6.83,6.74-6.83s6.7,2.24,6.7,6.87v.19Z",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M517.4-185.66a8.06,8.06,0,0,1,8.29-8.42,7.21,7.21,0,0,1,6.67,3.73h.06v-10.3h2.17v14.89c0,5.09-3.52,8.52-8.57,8.52a8.22,8.22,0,0,1-8.62-8.42m15,0a6.15,6.15,0,0,0-6.4-6.41,6.16,6.16,0,0,0-6.42,6.41,6.16,6.16,0,0,0,6.42,6.41,6.15,6.15,0,0,0,6.4-6.41",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M538.94-198a1.66,1.66,0,0,1,1.65-1.65,1.66,1.66,0,0,1,1.65,1.65,1.68,1.68,0,0,1-1.65,1.66,1.68,1.68,0,0,1-1.65-1.66m.58,4.34h2.17v16h-2.17Z",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M547-177.66V-194.3c0-4.51,2.75-6.77,6.73-6.77s6.7,2.3,6.7,6.86h-2.13c0-3.33-1.85-4.85-4.57-4.85s-4.56,1.52-4.56,4.76v2.88h9.38v2h-9.38v11.79Z",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M576.24-193.66h2.17v15.41c0,5.57-3.53,7.84-8,7.84-3.63,0-6.64-1.68-7.65-5.15h2.17c.84,2.17,2.82,3.24,5.48,3.24,3.43,0,5.82-1.68,5.82-5.86v-2.56h-.06a6.37,6.37,0,0,1-6,3.4c-4.27,0-7.58-2.59-7.58-8.06v-8.26h2.17v8.26c0,4,2.27,6.05,5.73,6.05s5.73-2.13,5.73-6.05Z",
    transform: "translate(-381.75 217.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M585.71-196.65h.57c.67,0,1.2-.22,1.2-.76s-.34-.79-1.1-.79a2.45,2.45,0,0,0-.67.07Zm0,2.91h-1.2v-5.15a9.66,9.66,0,0,1,2-.19,3,3,0,0,1,1.81.41,1.43,1.43,0,0,1,.5,1.11,1.33,1.33,0,0,1-1.07,1.23v.06a1.51,1.51,0,0,1,.95,1.27,3.35,3.35,0,0,0,.37,1.26h-1.29a3.86,3.86,0,0,1-.41-1.23c-.1-.57-.41-.82-1.08-.82h-.57Zm.79-6.83a4,4,0,0,0-4,4.14,4,4,0,0,0,4,4.15,4,4,0,0,0,4-4.15,4,4,0,0,0-4-4.14Zm.07-1a5.19,5.19,0,0,1,5.28,5.18,5.18,5.18,0,0,1-5.32,5.22,5.23,5.23,0,0,1-5.34-5.22,5.24,5.24,0,0,1,5.34-5.18Z",
    transform: "translate(-381.75 217.1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardifyLogoLight);
export default __webpack_public_path__ + "static/media/gardifyLogoLight.8f35a0a3283c73ce3f191665481647f2.svg";
export { ForwardRef as ReactComponent };